import styles from "./BpsSegmentedControl.module.scss";

export type BpsSegment = {
	id: string;
	label: string;
};

interface BpsSegmentedControlProps {
	segments: BpsSegment[];
	activeSegmentId: string;
	onSegmentChange: (id: string) => void;
}

/** Pill switch of the BPS admin screens — one choice out of a short, fixed set. */
export function BpsSegmentedControl({
	segments,
	activeSegmentId,
	onSegmentChange,
}: Readonly<BpsSegmentedControlProps>) {
	return (
		<div className={styles.control} role="tablist">
			{segments.map(segment => (
				<button
					key={segment.id}
					type="button"
					role="tab"
					aria-selected={segment.id === activeSegmentId}
					className={`${styles.segment} ${segment.id === activeSegmentId ? styles.active : ""}`}
					onClick={() => onSegmentChange(segment.id)}
				>
					{segment.label}
				</button>
			))}
		</div>
	);
}
